import { useState } from "react";

export const useOrganisations = () => {
  const [organisations, setOrganisationsInternal] = useState(() => {
    try {
      const org = localStorage.getItem("organisations");
      return org ? JSON.parse(org) : null;
    } catch (error) {
      console.error("Error parsing organisations:", error);
      return null;
    }
  });

  const [usedOrganisations, setUsedOrganisationsInternal] = useState(() => {
    try {
      const org = localStorage.getItem("usedorganisations");
      return org ? JSON.parse(org) : null;
    } catch (error) {
      console.error("Error parsing usedorganisations:", error);
      return null;
    }
  });

  const setOrganisations = (org) => {
    try {
      // If org is already a string, parse it first to get the array
      const organisationsArray = typeof org === 'string' ? JSON.parse(org) : org;
      
      localStorage.setItem("organisations", JSON.stringify(organisationsArray));
      setOrganisationsInternal(organisationsArray);
      
      // Set the first organisation as usedOrganisations if array exists and has items
      if (organisationsArray && organisationsArray.length > 0) {
        setUsedOrganisations(organisationsArray[0]);
      }
    } catch (error) {
      console.error("Error setting organisations:", error);
    }
  };

  const setUsedOrganisations = (org) => {
    try {
      console.log("Setting used organisation:", org);
      localStorage.setItem("usedorganisations", JSON.stringify(org.id));
      setUsedOrganisationsInternal(org);
    } catch (error) {
      console.error("Error setting used organisation:", error);
    }
  };

  return [organisations, setOrganisations, usedOrganisations, setUsedOrganisations];
};